(() => {
  const initialise = () => {
    document.querySelectorAll('[data-bb-finder]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const form = root.querySelector('form');
      const results = root.querySelector('.bb-finder-results');
      const cards = Array.from(root.querySelectorAll('[data-finder-card]'));
      const messages = JSON.parse(root.querySelector('[data-finder-messages]').textContent);
      form.addEventListener('submit', event => {
        event.preventDefault();
        if (!form.reportValidity()) return;
        const answers = new FormData(form);
        const method = answers.get('method');
        const flavour = answers.get('flavour');
        const bitterness = answers.get('bitterness');
        const methodMatches = cards.filter(card => card.dataset.methods.split(/\s+/).includes(method));
        const exact = methodMatches.filter(card =>
          (flavour === 'any' || Number(card.dataset[flavour]) > 0) &&
          card.dataset.bitterness === bitterness
        );
        const score = card => (flavour === 'any' ? 0 : Number(card.dataset[flavour]) * 3) + (bitterness === 'strong' ? Number(card.dataset.bitterRank) * 100 : 0);
        const levels = { mild: 0, medium: 1, strong: 2 };
        const distance = card => Math.abs(levels[card.dataset.bitterness] - levels[bitterness]);
        const flavourMatch = card => flavour === 'any' || Number(card.dataset[flavour]) > 0;
        const fallback = exact.length === 0 && methodMatches.length > 0;
        const selected = (fallback ? methodMatches : exact).slice().sort((a, b) =>
          (fallback ? distance(a) - distance(b) || Number(flavourMatch(b)) - Number(flavourMatch(a)) : 0) || score(b) - score(a)
        ).slice(0, 3);
        cards.forEach(card => { card.hidden = !selected.includes(card);  });
        selected.forEach(card => root.querySelector('.bb-finder-grid').append(card));
        const message = root.querySelector('[data-finder-message]');
        message.textContent = fallback ? messages.nearest : selected.length ? messages.match : messages.none;
        if (!fallback && selected.length === 1) message.textContent += ' ' + messages.partial;
        results.hidden = false;
        root.querySelector('[data-finder-heading]').focus({ preventScroll: true });
        results.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'nearest' });
      });
      root.querySelector('.bb-finder-reset').addEventListener('click', () => {
        form.reset();
        results.hidden = true;
        cards.forEach(card => { card.hidden = true; });
        form.querySelector('input').focus({ preventScroll: true });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise);
  else initialise();
  document.addEventListener('shopify:section:load', initialise);
})();

